import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  API_ADD_USER,
  API_ADD_COMPANY,
  API_GET_CUSTOMERS,
  API_ADD_SUBSCRIPTION,
  API_PUT_COMPANY_REQUEST,
  getPlans,
} from "../api/cust.service";

const initialState = {
  loading: false,
  cform: "",
  customerData: [],
  selectedcustomers: [],
  plans: [],
  header: "",
  totalCustomerCount: 0,
  page: 0,
  limit: 10,
  mode: null,
  refresher: true,
};
export const PlansDetails = createAsyncThunk(
  "customer/getPlansDetails",
  async (thunkAPI) => {
    try {
      const data = await getPlans();
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const getCustomers = createAsyncThunk(
  "customer/getCustomerList",
  async ({ page, limit, searchText }, thunkAPI) => {
    try {
      const customers = await API_GET_CUSTOMERS(page, limit, searchText);
      return customers;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const addCompany = createAsyncThunk(
  "customer/addCompany",
  async ({ data }, thunkAPI) => {
    // console.log(data);
    try {
      const resp = await API_ADD_COMPANY(data);
      return resp;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const addUser = createAsyncThunk(
  "customer/addUser",
  async ({ data }, thunkAPI) => {
    try {
      const resp = await API_ADD_USER(data);
      return resp;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const addSubscription = createAsyncThunk(
  "customer/addSubscription",
  async ({ data }, thunkAPI) => {
    try {
      const resp = await API_ADD_SUBSCRIPTION(data);
      return resp;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

export const putCompany = createAsyncThunk(
  "customer/putCompany",
  async ({ data }, thunkAPI) => {
    try {
      const resp = await API_PUT_COMPANY_REQUEST(data);
      return resp;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);

const customerSlice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    changeMode(state, action) {
      state.mode = action.payload;
    },
    resetMode(state) {
      state.mode = null;
    },
    changePage(state, action) {
      state.page = action.payload;
    },
    changelimit(state, action) {
      state.limit = action.payload;
    },
    resetSelectedCustomer(state) {
      state.selectedcustomers = [];
    },
    changeSelectedCustomer(state, action) {
      state.selectedcustomers = action.payload;
    },
    setCform(state, action) {
      state.cform = action.payload;
      if (action.payload === "company") {
        state.header = `${state.mode == "update" ? "Update" : "Add"} Customer`;
      }
      if (action.payload === "user") {
        state.header = `Users`;
      }
      if (action.payload === "subscription") {
        state.header = `${
          state.mode == "update" ? "Update" : "Add"
        } Subscription`;
      }
    },
  },

  extraReducers: (builder) => {
    builder.addCase(getCustomers.fulfilled, (state, action) => {
      state.totalCustomerCount = action.payload.count;
      state.customerData = action.payload.rows;
      state.loading = false;
    });
    builder.addCase(getCustomers.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getCustomers.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addCompany.fulfilled, (state, action) => {
      // state.totalCustomerCount = action.payload.count;
      // state.customerData = action.payload.data;
      state.loading = false;
      state.refresher = !state.refresher;
    });
    builder.addCase(addCompany.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addCompany.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addUser.fulfilled, (state, action) => {
      state.loading = false;
      state.refresher = !state.refresher;
    });
    builder.addCase(addUser.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addUser.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(addSubscription.fulfilled, (state, action) => {
      state.loading = false;
      state.refresher = !state.refresher;
    });
    builder.addCase(addSubscription.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addSubscription.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(PlansDetails.fulfilled, (state, action) => {
      state.plans = action.payload.rows;
      state.loading = false;
    });
    builder.addCase(PlansDetails.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(PlansDetails.rejected, (state) => {
      state.loading = false;
    });
  },
});

export const {
  changeMode,
  resetMode,
  changePage,
  setCform,
  resetSelectedCustomer,
  changeSelectedCustomer,
  changelimit,
} = customerSlice.actions;

export default customerSlice.reducer;
